const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Login ID',
        dataIndex: 'loginId',
    },
    {
        title: 'Create Date',
        dataIndex: 'createdDate',
    },
    {
        title: 'Status',
        dataIndex: 'isActive',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];

export default columns;
